import beansStore from './beansStore';

export default {
  install(store) {
    if (!store.state.base) {
      store.registerModule(['base'], {
        state: {},
      });
    }
    if (!store.state.base.beans) {
      store.registerModule(['base', 'beans'], beansStore);
    }
  },
  uninstall(store) {
    store.unregisterModule(['base', 'beans']);
  },
};
